import { FC, useState } from 'react';
import { BsInfoCircle } from 'react-icons/bs';

interface InfoTooltipProps {
  content: string;
  iconSize?: number;
  iconColor?: string;
  className?: string; // 👈 layout control
}

const InfoTooltip: FC<InfoTooltipProps> = ({
  content,
  iconSize = 22,
  iconColor = '#1133BB',
  className,
}) => {
  const [visible, setVisible] = useState(false);

  return (
    <div
      className={`relative inline-flex ${className || ''}`}
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
      onClick={e => e.stopPropagation()}
    >
      <BsInfoCircle
        size={iconSize}
        color={iconColor}
        className='cursor-pointer'
      />

      {visible && (
        <div className='absolute top-full right-0 mt-2 w-60 bg-white border border-gray-300 rounded-md shadow-md z-50 p-2'>
          <p className='text-sm whitespace-normal'>{content}</p>
        </div>
      )}
    </div>
  );
};

export default InfoTooltip;
